import PropTypes from 'prop-types';
import { TripTypeProp, TripTypePropDefault } from './TripType';
import { FlightClassProp, FlightClassPropDefault } from './FlightClass';
import { SearchSegment } from './SearchSegment';
import { LocationProp } from './Location';
import { PaxProps, PaxPropsDefault } from './Pax';

export const SearchProp = PropTypes.shape({
    cabinClass: FlightClassProp.isRequired,
    isDirect: PropTypes.bool.isRequired,
    isResident: PropTypes.bool.isRequired,
    pax: PaxProps.isRequired,
    segments: PropTypes.arrayOf(SearchSegment).isRequired,
    tripType: TripTypeProp.isRequired,
});

// TODO: update unit test to clone from this object
export const SearchPropDefault = {
    cabinClass: FlightClassPropDefault,
    isDirect: false,
    isResident: false,
    pax: PaxPropsDefault,
    segments: [],
    tripType: TripTypePropDefault,
    isHotel: false,
    separateStay: { enabled: false },
    rooms: [],
};

export const SearchRequestProp = PropTypes.shape({
    cabinClass: FlightClassProp.isRequired,
    directFlightsOnly: PropTypes.bool.isRequired,
    resident: PropTypes.bool,
    numAdults: PropTypes.number.isRequired,
    numChildren: PropTypes.number.isRequired,
    numInfants: PropTypes.number.isRequired,
    isInspirationalSearch: PropTypes.bool,
    searchSegments: PropTypes.arrayOf(PropTypes.shape({
        departure: LocationProp,
        destination: LocationProp,
        dateStr: PropTypes.string,
    })).isRequired,
    type: TripTypeProp.isRequired,
});
